import { useQuery } from '@tanstack/react-query';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { getExtensions } from 'src/api/extensions';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from 'src/constants/QueryKeys';

export const useExtensions = (brandId: string | undefined) => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();

  return useQuery({
    queryKey: [QueryKeys.EXTENSIONS, brandId],
    queryFn: () => {
      if (!brandId) {
        throw new Error('Brand ID is required');
      }
      return getExtensions(brandId);
    },
    enabled: !!brandId,
    onError: (e: Error) => {
      showSnackbar({
        message: e.message,
        status: SnackbarStatus.ERROR,
      });
      captureException(e);
    },
  });
};
